<template>
  <div>
    <b-card no-body>
      <b-card-body class="text-right">
        <b-button
          variant="primary"
          :to="$route.path + '/add'"
        >
          <FeatherIcon icon="PlusIcon" /> Oluştur
        </b-button>
      </b-card-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(control)="data">
            <div class="text-right">
              <list-buttons
                :edit-action="$route.path + '/edit/' + data.item.id"
                :delete-action="removeData"
                :data-id="data.item.id"
              />
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-alert
        v-else
        variant="info"
        class="m-2 text-center"
        show
      >
        <div class="alert-body">
          <feather-icon icon="InfoIcon" />
          Kayıtlı kategoriniz bulunmuyor.
        </div>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BButton, BTable, BCardFooter, BPagination, BAlert,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'branches'

export default {
  name: 'PageIndex',
  components: {
    BAlert,
    BPagination,
    BCardFooter,
    ListButtons,
    BTable,
    BCard,
    BCardBody,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      baseUrl: this.$store.state.app.baseURL,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Şube Adı',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          'users.name AS username',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['branches/dataList']
    },
    dataCounts() {
      return this.$store.getters['branches/dataCounts']
    },
    saveData() {
      return this.$store.getters['branches/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success',
          title: 'İşlem Başarılı!',
          icon: 'CheckIcon',
          text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger',
          title: 'İşlem Hatası!',
          icon: 'XIcon',
          text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('branches/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('branches/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
